import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface QrAuthState {
    readonly isQrCodeMatched: boolean
}

const initialQrCodeState: QrAuthState = {
    isQrCodeMatched: false,
}

export const qrAuthSlice = createSlice({
    name: 'qrAuth',
    initialState: initialQrCodeState,
    reducers: {
        setQrCodeMatched: (state, action: PayloadAction<boolean>) => {
            state.isQrCodeMatched = action.payload
        },
        clearQrState: (state) => {
            state.isQrCodeMatched = false
        },
    },
})

export const { setQrCodeMatched, clearQrState } = qrAuthSlice.actions

export const qrAuthReducer = qrAuthSlice.reducer
